import { render, staticRenderFns } from "./app-basket.vue?vue&type=template&id=5bfa61c1&"
import script from "./app-basket.vue?vue&type=script&lang=js&"
export * from "./app-basket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports